<template>
  <div class="days">
    <h4 class="days__title">Itinerary</h4>
    <div v-for="(day, index) in days" :key="day.id" class="days__wrapper">
      <p class="days__time">
        <span class="days__time-day">Day {{ index + 1 }}</span>
        <span class="days__time-date">
          {{ formatDate(day) }}
          <i
            class="bootcamp__timezone-icon material-icons info-icon"
            role="presentation"
            v-tooltip="{
              content: `Local time: ${localTimeZone}`,
              placement: 'top-center',
            }"
          >
            info_outline
          </i>
        </span>
      </p>
      <div class="days__panel">
        <p class="days__description" v-html="day.description_html"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns-tz'
import { localTimezone } from '@/helpers/mixins'

export default {
  name: 'Days',
  mixins: [localTimezone],
  data() {
    return {
      selectedDay: null,
    }
  },
  props: {
    days: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatDate(day) {
      const startDate = new Date(day.start_datetime)
      const endDate = new Date(day.end_datetime)
      return `
        ${format(new Date(startDate), 'LLL do, hh:mm a')} - 
        ${format(new Date(endDate), 'hh:mm a')}
      `
    },
  },
  created() {
    this.selectedDay = this.days[0]
  },
}
</script>

<style lang="scss">
.days {
  &__title {
    color: var(--white);
    margin: 0 auto 25px auto;
    text-align: center;
    font-size: rem(18px);
    font-family: var(--font-bold);
    text-transform: uppercase;
    line-height: 1rem;
  }
  &__time {
    color: var(--orange);
    text-transform: uppercase;
    width: 100%;
    padding: 15px;
    font-size: rem(15px);
    background: var(--dark-gray);
    border: none;
    cursor: pointer;
    border: 1px solid var(--highlight-gray);
    border-bottom: none;
    margin: 0 auto;
    display: flex;
    &-date {
      margin-left: auto;
      text-align: right;
      display: flex;
      align-items: center;
    }
  }
  &__panel {
    background: var(--highlight-gray);
    color: var(--white);
    padding: 20px;
    margin: 0 0 20px 0;
  }
}
</style>
